import React from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Button,
} from "@mui/material";

export default function AlertDialog({ open, onDelete, onCancel }) {
  return (
    <Dialog
      open={open}
      onClose={onCancel}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
       BackdropProps={{
    sx: {
      backdropFilter: 'blur(4px)', 
      backgroundColor: 'rgba(0, 0, 0, 0.2)', 
    },
  }}
    >
      <DialogTitle id="alert-dialog-title">{"Delete Confirmation"}</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          Are you sure you want to delete this item? This action cannot be
          undone.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel} color="primary" variant="outlined" sx={{borderRadius:"10px",textTransform:"none"}}>
          Cancel
        </Button>
        <Button
          onClick={onDelete}
          sx={{
            background: "linear-gradient(to right, #5301d7, #008eca)",
            color: "white",
            borderRadius: "10px",
            textTransform:"none"
          }}
          autoFocus
          variant="contained"
        >
          Delete
        </Button>
      </DialogActions>
    </Dialog>
  );
}
